$(() => {
    $('form.bootstrap-form.needs-validation').submit((event) => {
        checkPasswords();
        validateForm(event);
    });

    $('form#reset-password-form.needs-validation').submit((event) => validateForm(event));

    $('form.bootstrap-form .form-control').on('input', (event) => {
        if ($('form.bootstrap-form').hasClass('was-validated')) {
            checkPasswords();
            event.target.checkValidity();
        }
    });

    const validateForm = (event) => {
        const $form = $(event.target);
        if ($form.get(0).checkValidity() === false) {
            event.preventDefault();
            event.stopPropagation();
        }
        $form.addClass('was-validated');
    };

    const checkPasswords = () => {
        const newPassword = $('.bootstrap-form [data-password="new"]');
        const confirmPassword = $('.bootstrap-form [data-password="confirm"]');
        if (newPassword.length == 0 && confirmPassword.length == 0) {
            return;
        }

        confirmPassword
            .get(0)
            .setCustomValidity(
                newPassword.val() != confirmPassword.val() ? 'Lösenorden måste stämma överens' : ''
            );
    };
});
